import { render } from "./Framee.vue?vue&type=template&id=b1fb04d4&scoped=true"
import script from "./Framee.vue?vue&type=script&lang=js"
export * from "./Framee.vue?vue&type=script&lang=js"

import "./Framee.vue?vue&type=style&index=0&id=b1fb04d4&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-b1fb04d4"

export default script